import React from "react";

export default function Logo() {
  return (
    <svg
      width="82"
      height="30"
      viewBox="0 0 82 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0290662 18.7732L3.57151 17.1854C3.96754 18.2137 4.5961 19.7687 6.81603 19.7687C8.43648 19.7687 9.03597 18.9403 9.03597 18.2791C9.03597 15.7612 0.922853 17.2508 0.922853 11.325C0.91922 7.91331 3.93484 6.3728 6.97953 6.3728C9.88616 6.3728 12.0443 7.76435 13.3014 9.94795L9.86799 11.8881C9.37023 10.9943 8.61088 9.80262 6.8887 9.80262C5.79872 9.80262 5.16653 10.3331 5.16653 10.9616C5.16653 13.2797 13.4431 11.7573 13.4431 17.814C13.4431 21.7525 9.99879 23.442 6.90323 23.442C3.39348 23.442 0.777522 21.1893 0 18.7732"
        fill="#394277"
      />
      <path
        d="M20.5497 10.2639V17.8139C20.5497 18.7731 20.9458 19.7323 22.6025 19.7323C23.3013 19.7164 23.9936 19.5939 24.6553 19.3689V22.9114C23.6411 23.2738 22.5713 23.4557 21.4944 23.4491C18.5878 23.4491 16.0663 22.0249 16.0663 18.1845V10.2639H13.4321V6.75417H16.0808V3.97471L20.5497 0.664795V6.75417H24.6553V10.2639H20.5497Z"
        fill="#394277"
      />
      <path
        d="M25.8545 0H30.4906V4.07291H25.8545V0ZM25.9199 6.75427H30.4215V23.0859H25.9344L25.9199 6.75427Z"
        fill="#394277"
      />
      <path
        d="M66.151 16.4224H55.1931C55.3929 18.1446 56.5519 19.369 58.899 19.369C59.6 19.3879 60.296 19.2457 60.9334 18.9535C61.5708 18.6612 62.1327 18.2266 62.5759 17.6832L65.686 20.4299C64.8407 21.403 63.7914 22.178 62.6127 22.6998C61.4341 23.2217 60.155 23.4775 58.8663 23.4492C53.0531 23.4492 50.7241 19.2782 50.7241 15.0054C50.7241 10.8344 52.9731 6.39819 58.6011 6.39819C63.6877 6.39819 66.2491 10.1078 66.2491 14.8746C66.2461 15.3944 66.2134 15.9136 66.151 16.4297V16.4224ZM61.98 13.018C61.9146 11.2305 60.425 10.1368 58.5684 10.1368C56.283 10.1368 55.3566 11.6919 55.1567 13.018H61.98Z"
        fill="#394277"
      />
      <path
        d="M81.7379 16.4225H70.7763C70.9762 18.1446 72.1352 19.369 74.4823 19.369C75.186 19.3897 75.885 19.2481 76.5252 18.9551C77.1653 18.6621 77.7294 18.2257 78.1737 17.6796L81.2838 20.4263C80.4378 21.4017 79.3869 22.1784 78.2062 22.7009C77.0255 23.2234 75.744 23.479 74.4532 23.4492C68.64 23.4492 66.311 19.2782 66.311 15.0055C66.3074 10.8272 68.56 6.3728 74.1771 6.3728C79.2637 6.3728 81.807 10.0824 81.807 14.8492C81.804 15.369 81.7712 15.8882 81.7089 16.4043L81.7379 16.4225ZM77.5379 12.9926C77.4725 11.2051 75.9828 10.1114 74.1262 10.1114C71.8409 10.1114 70.9144 11.6665 70.7146 12.9926H77.5379Z"
        fill="#394277"
      />
      <path
        d="M36.3291 15.8882H32.02V29.9998H36.3291V15.8882Z"
        fill="#DD8D37"
      />
      <path
        d="M41.114 19.8958C39.974 19.8949 38.8703 19.4946 37.9948 18.7645C37.1193 18.0343 36.5273 17.0205 36.3217 15.8992H32.0635C32.246 18.1752 33.279 20.299 34.9569 21.8477C36.6347 23.3963 38.8343 24.2563 41.1176 24.2563C43.4009 24.2563 45.6005 23.3963 47.2784 21.8477C48.9562 20.299 49.9892 18.1752 50.1717 15.8992H45.9099C45.7043 17.0205 45.1123 18.0343 44.2368 18.7645C43.3613 19.4946 42.2576 19.8949 41.1176 19.8958"
        fill="#FAAA31"
      />
      <path
        d="M50.2155 13.1233V6.57251H32.02V13.1233H36.2455V13.1306V10.798H45.99V13.1378L45.9936 13.1233H50.2155Z"
        fill="#FAAA31"
      />
      <path d="M32.02 13.5667H32.0273L32.02 13.1416V13.5667Z" fill="#FAAA31" />
      <path
        d="M50.2153 13.1523L50.208 13.5665H50.2153V13.1523Z"
        fill="#FAAA31"
      />
      <path
        d="M50.2156 13.1233H45.9937L45.9901 13.1378L45.9102 15.8882H50.172L50.2083 13.5666L50.2156 13.1524V13.1233Z"
        fill="#FAAA31"
      />
      <path
        d="M32.02 13.1233V13.1415L32.0273 13.5666L32.0636 15.8882H36.3255L36.2455 13.1306V13.1233H32.02Z"
        fill="#FAAA31"
      />
      <g opacity="0.21">
        <g opacity="0.21">
          <path
            opacity="0.21"
            d="M41.114 19.8958C39.974 19.8949 38.8703 19.4946 37.9948 18.7645C37.1193 18.0343 36.5273 17.0205 36.3217 15.8992H32.0635C32.246 18.1752 33.279 20.299 34.9569 21.8477C36.6347 23.3963 38.8343 24.2563 41.1176 24.2563C43.4009 24.2563 45.6005 23.3963 47.2784 21.8477C48.9562 20.299 49.9892 18.1752 50.1717 15.8992H45.9099C45.7043 17.0205 45.1123 18.0343 44.2368 18.7645C43.3613 19.4946 42.2576 19.8949 41.1176 19.8958"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
}
